import React from "react";
import BaseDndItem from "./BaseDndItem";

const CADndItem = (props) => {
  return <BaseDndItem {...props} type='caSchedule' scheduleLabel='Schedule' />;
};

export default CADndItem;
